module.exports = __webpack_public_path__ + "static/media/painFree.c7c09280.png";